import OverviewContainer from './components/OverviewContainer';

export default store => ({
  path: 'overview',
  indexRoute: {
    component: OverviewContainer
  }
});



// WEBPACK FOOTER //
// ./src/client/plugins/overview/index.js